// extracted by mini-css-extract-plugin
export default {"container":"DateRangePicker_container__zp+6v","search":"DateRangePicker_search__TmVYU"};